export const LogoMark = ({ className = "h-7" }) => (
  <img
    src={process.env.PUBLIC_URL + "/logo-horizontal.png"}
    alt="Ramaani Electricals"
    className={`w-auto ${className}`}
  />
);

export const LogoFull = ({ className = "h-16" }) => (
  <img
    src={process.env.PUBLIC_URL + "/logo-full.png"}
    alt="Ramaani Electricals — Vijayawada"
    className={`w-auto ${className}`}
  />
);
